import type { Route } from '@angular/router';
import { UserDtoService } from './service/user-dto.service';

export const userRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/./user-list.component'),
    pathMatch: 'full',
    providers: [UserDtoService],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
